(function () {
  'use strict';

  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var pageSize = 24;

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }

  function finishCardLoading(cards, detail) {
    cards.forEach(function (card) { card.removeAttribute('data-' + detail + '-loading'); });
  }

  function safeProductPath(path) {
    return typeof path === 'string' && /^\/products\/[a-z0-9-]+(?:\?.*)?$/i.test(path) ? path : null;
  }

  function safeImageUrl(value) {
    if (typeof value !== 'string') return null;
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' && /(^|\.)shopifycdn\.net$|(^|\.)cdn\.shopify\.com$/.test(url.hostname) ? url.href : null;
    } catch (_) { return null; }
  }

  function safeBannerLink(value) {
    if (typeof value !== 'string') return null;
    if (value.startsWith('/') && !value.startsWith('//') && !value.includes('\\')) return value;
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
    } catch (_) { return null; }
  }

  function productHandle(path) {
    var match = /^\/products\/([a-z0-9-]+)(?:\?.*)?$/i.exec(path || '');
    return match ? match[1] : null;
  }

  function swatchColour(value, custom) {
    var name = String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
    var colours = {
      black: '#222936', 'gloss black': '#222936', 'ultra gloss black': '#222936',
      'satin black': '#292b31', anthracite: '#41434a', 'gloss anthracite': '#41434a', 'matt anthracite': '#41434a',
      'ultra gloss anthracite': '#41434a', 'jet black': '#16181d', 'piano white': '#f8f8f5',
      white: '#ffffff', 'gloss white': '#ffffff', 'ultra gloss white': '#ffffff',
      grey: '#888b90', gray: '#888b90', 'slate grey': '#626a71', 'dusty grey': '#a3a2a1',
      'driftwood grey': '#85847e', 'basalt gray': '#565b5d', 'basalt grey': '#565b5d', silver: '#bcc3cc',
      blue: '#bfdbfe', 'wild blue': '#60a5fa', navy: '#1e3a5f',
      red: '#fda4af', pink: '#f9a8d4', green: '#86c99b', forest: '#456b51',
      brown: '#a47750', oak: '#bd976b', 'gloss oak': '#bd976b', 'wild oak': '#af865c',
      'light wood': '#d1b796', 'natural wood': '#c9ae86', walnut: '#72513d',
      'driftwood concrete': '#9e9b94', 'carbon oak': '#514b43', 'natural oak': '#c7a77e',
      'tobacco oak': '#8b6546', 'platinum oak': '#b7b4ac',
      'grey oak': '#8f8779', 'oak grey': '#8f8779', 'grey nebraska oak': '#a6a093',
      'natural nebraska oak': '#b99d78', 'hampshire oak': '#ae8b67', 'hunton oak': '#ad8b65',
      'kendal oak': '#bd9872', 'bardolino oak': '#b4926c',
      'pasedena pine': '#c4ab86', pine: '#c4ab86',
      'boston concrete': '#a4a3a0', 'chicago concrete': '#969795', 'brushed limestone': '#c3bdb1',
      'black obsidian smoked oak': '#37342f', 'kansas truffle walnut': '#796652',
      beige: '#d9c5a9', cream: '#f5efdc', 'soft cashmere': '#d9d0c0',
      gold: '#c9a458', clear: '#f4f4f5', snow: '#f8f8f6',
      mystic: '#71777b', urban: '#777b7a',
      'black aquarium and black cabinet': '#222936',
      'white aquarium and white cabinet': '#ffffff',
      'mystic aquarium and mystic cabinet': '#71777b',
      'mystic aquarium and marble cabinet': 'linear-gradient(135deg,#71777b 50%,#e5e1da 50%)',
      'white aquarium and oak cabinet': 'linear-gradient(135deg,#ffffff 50%,#bd976b 50%)',
      'black aquarium and black marble cabinet': 'linear-gradient(135deg,#222936 50%,#4f5054 50%)',
      'mystic aquarium and black marble cabinet': 'linear-gradient(135deg,#71777b 50%,#4f5054 50%)',
      'white aquarium and oasis oak cabinet': 'linear-gradient(135deg,#ffffff 50%,#c3a27d 50%)'
    };
    var override = custom && Object.prototype.hasOwnProperty.call(custom, name) ? custom[name] : null;
    if (typeof override === 'string' && /^#[0-9a-f]{6}$/i.test(override)) return override;
    return colours[name] || colours[name.replace(/^(?:ultra |high )?(?:gloss |matt |matte |satin )/, '')] || null;
  }

  function renderColourSwatches(card, item, path, custom) {
    if (card.querySelector('.discovery-collection__swatches')) return;
    var options = Array.isArray(item.options) ? item.options : [];
    var colourIndex = options.findIndex(function (option) {
      return /^(colou?r|finish)$/i.test(String(typeof option === 'string' ? option : option && option.name).trim());
    });
    if (colourIndex < 0 || !Array.isArray(item.variants)) return;
    var seen = new Set();
    var values = item.variants.map(function (variant) {
      var value = Array.isArray(variant.options) ? variant.options[colourIndex] : variant['option' + (colourIndex + 1)];
      value = String(value || '').trim();
      if (!value || seen.has(value.toLowerCase()) || !/^\d+$/.test(String(variant.id || ''))) return null;
      seen.add(value.toLowerCase());
      return { value: value, variant: variant };
    }).filter(Boolean);
    if (values.length < 2) return;
    var row = element('div', 'discovery-collection__swatches');
    row.setAttribute('aria-label', 'Available colours');
    values.slice(0, 5).forEach(function (choice, index) {
      var variantId = String(choice.variant.id || '');
      var link = element('a', 'discovery-collection__swatch');
      link.href = path.split('?')[0] + '?variant=' + encodeURIComponent(variantId);
      link.setAttribute('aria-label', choice.value);
      link.title = choice.value;
      if (index === 0) link.dataset.selected = 'true';
      var colour = swatchColour(choice.value, custom);
      if (colour) {
        link.style.setProperty('--swatch-colour', colour);
      } else {
        link.dataset.unmapped = 'true';
        link.appendChild(element('span', 'discovery-collection__swatch-letter', choice.value.slice(0, 1).toUpperCase()));
      }
      row.appendChild(link);
    });
    appendSwatchCount(row, values.length);
    if (row.childElementCount) card.querySelector('.discovery-collection__details').appendChild(row);
  }

  function appendSwatchCount(row, total) {
    [[5, 'desktop'], [3, 'mobile'], [2, 'narrow']].forEach(function (limit) {
      var remaining = total - limit[0];
      if (remaining <= 0) return;
      var count = element('span', 'discovery-collection__swatch-more discovery-collection__swatch-more--' + limit[1]);
      count.textContent = '+ ' + remaining + ' ' + (remaining === 1 ? 'colour' : 'colours');
      row.appendChild(count);
    });
  }

  function renderSiblingSwatches(card, hit, custom) {
    var choices = Array.isArray(hit.swatches) ? hit.swatches.filter(function (choice) {
      return safeProductPath(choice.url);
    }) : [];
    if (choices.length < 2) return;
    choices.sort(function (a, b) {
      return Number(b.shopifyId === hit.shopifyId) - Number(a.shopifyId === hit.shopifyId);
    });
    var row = element('div', 'discovery-collection__swatches');
    row.setAttribute('aria-label', 'Available colours');
    choices.slice(0, 5).forEach(function (choice) {
      var path = safeProductPath(choice.url);
      var link = element('a', 'discovery-collection__swatch');
      link.href = path;
      link.setAttribute('aria-label', String(choice.label || 'View colour'));
      link.title = String(choice.label || 'View colour');
      if (choice.shopifyId === hit.shopifyId) link.dataset.selected = 'true';
      var colour = swatchColour(choice.label, custom);
      if (colour) link.style.setProperty('--swatch-colour', colour);
      else {
        link.dataset.unmapped = 'true';
        link.appendChild(element('span', 'discovery-collection__swatch-letter', String(choice.label || '?').slice(0, 1).toUpperCase()));
      }
      row.appendChild(link);
    });
    appendSwatchCount(row, choices.length);
    if (row.childElementCount) card.querySelector('.discovery-collection__details').appendChild(row);
  }

  function deliveryMessage(result, messages) {
    if (!result || result.status === 'unavailable') return null;
    if (result.status === 'sold_out') return { text: messages.soldOut || 'Sold out', tone: 'warn' };
    if (!result.delivery) return { text: messages.awaitingStock || 'Awaiting stock', tone: 'info' };
    var date = new Date(result.delivery + 'T12:00:00Z');
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== result.delivery) return null;
    var day = date.getUTCDate();
    var suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
    var label = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/London' })
      .formatToParts(date).map(function (part) { return part.type === 'day' ? part.value + suffix : part.value; }).join('');
    var template = result.status === 'backorder' ? (messages.backorder || 'Expected by {date}') :
      (messages.getItBy || 'Get it by {date}');
    return { text: template.replaceAll('{date}', label), tone: result.status === 'in_stock' ? 'ok' : 'info' };
  }

  function bestVariantEstimate(variantIds, estimates) {
    var priority = { in_stock: 0, backorder: 1, awaiting_stock: 2, sold_out: 3 };
    return variantIds.map(function (id) { return estimates.get('gid://shopify/ProductVariant/' + id); })
      .filter(function (result) { return result && Object.prototype.hasOwnProperty.call(priority, result.status); })
      .sort(function (left, right) {
        return priority[left.status] - priority[right.status] ||
          String(left.delivery || '').localeCompare(String(right.delivery || ''));
      })[0] || null;
  }

  function ensureReviewsWidget() {
    if (typeof window.ratingSnippet === 'function') return Promise.resolve();
    if (window.__discoveryReviewsWidget) return window.__discoveryReviewsWidget;
    window.__discoveryReviewsWidget = new Promise(function (resolve) {
      if (!document.querySelector('link[href="https://widget.reviews.io/rating-snippet/dist.css"]')) {
        var css = element('link'); css.rel = 'stylesheet'; css.href = 'https://widget.reviews.io/rating-snippet/dist.css';
        document.head.appendChild(css);
      }
      var script = document.querySelector('script[src="https://widget.reviews.io/rating-snippet/dist.js"]');
      var created = !script;
      if (!script) {
        script = element('script');
        script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
      }
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', resolve, { once: true });
      if (created) document.head.appendChild(script);
      setTimeout(resolve, 5000);
    });
    return window.__discoveryReviewsWidget;
  }

  function bannerNode(banner, inline) {
    if (!banner || typeof banner !== 'object') return null;
    var imageUrl = safeImageUrl(banner.desktopImage);
    if (!imageUrl) return null;
    var article = element('article', 'discovery-collection__banner');
    if (inline) {
      article.classList.add('discovery-collection__banner--inline');
      var size = window.DiscoveryBannerSession.gridSize(banner);
      article.style.setProperty('--banner-desktop-columns', size.desktopColumns);
      article.style.setProperty('--banner-tablet-columns', size.tabletColumns);
      article.style.setProperty('--banner-desktop-rows', size.desktopRows);
      article.style.setProperty('--banner-tablet-rows', size.tabletRows);
      article.style.setProperty('--banner-mobile-columns', size.mobileColumns);
      article.style.setProperty('--banner-mobile-rows', size.mobileRows);
      window.DiscoveryBannerSession.applyAppearance(article, banner.style);
    }
    var picture = element('picture', 'discovery-collection__banner-media');
    var tabletUrl = safeImageUrl(banner.tabletImage);
    var mobileUrl = safeImageUrl(banner.mobileImage);
    if (mobileUrl || tabletUrl) {
      var source = element('source');
      source.media = '(max-width: 749px)';
      source.srcset = mobileUrl || tabletUrl;
      picture.appendChild(source);
    }
    if (tabletUrl) {
      var tabletSource = element('source');
      tabletSource.media = '(max-width: 1199px)';
      tabletSource.srcset = tabletUrl;
      picture.appendChild(tabletSource);
    }
    var image = element('img');
    image.src = imageUrl;
    image.alt = typeof banner.imageAlt === 'string' ? banner.imageAlt : '';
    image.loading = inline ? 'lazy' : 'eager';
    picture.appendChild(image);
    article.appendChild(picture);
    if (banner.heading || banner.body || banner.ctaLabel) {
      var copy = element('div', 'discovery-collection__banner-copy');
      if (banner.heading) copy.appendChild(element('h3', null, banner.heading));
      if (banner.body) copy.appendChild(element('p', null, banner.body));
      var href = safeBannerLink(banner.ctaUrl);
      if (href && banner.ctaLabel) {
        var cta = element('a', 'discovery-collection__banner-cta', banner.ctaLabel);
        cta.href = href;
        copy.appendChild(cta);
      }
      article.appendChild(copy);
    }
    return article;
  }

  function init(root) {
    if (root.dataset.discoveryReady === '1') return;
    root.dataset.discoveryReady = '1';
    var apiBase;
    try {
      apiBase = new URL(root.dataset.apiBase);
      if (apiBase.protocol !== 'https:') throw new Error('https required');
    } catch (_) {
      root.querySelector('[data-discovery-count]').textContent = 'Preview needs a valid HTTPS API URL';
      return;
    }
    var handle = root.dataset.collectionHandle;
    var collectionId = root.dataset.collectionId;
    var recordedPageView = false;
    function recordPageView() {
      if (root.dataset.recordEngagement === 'false') return;
      if (recordedPageView || !/^gid:\/\/shopify\/Collection\/[1-9]\d*$/.test(collectionId)) return;
      recordedPageView = true;
      fetch('/apps/charterhouse-discovery/collection-engagement', {
        method: 'POST', credentials: 'same-origin', keepalive: true, redirect: 'error', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'page_view', collectionId: collectionId })
      }).catch(function () { /* Analytics must never block shopping. */ });
    }
    var bannerSession = window.DiscoveryBannerSession && window.DiscoveryBannerSession.create(root.dataset.limitBannerRepeats === 'true');
    var form = root.querySelector('[data-discovery-filters]');
    var filterPanel = root.querySelector('[data-discovery-filters-panel]');
    var filterBackdrop = root.querySelector('[data-discovery-filter-backdrop]');
    var closeFilters = root.querySelector('[data-discovery-close-filters]');
    var applyFilters = root.querySelector('[data-discovery-apply-filters]');
    var filterToggle = root.querySelector('[data-discovery-toggle-filters]');
    var filterToggleLabel = root.querySelector('[data-discovery-filter-toggle-label]');
    var grid = root.querySelector('[data-discovery-grid]');
    var emptyStateBanners = root.querySelector('[data-discovery-empty-state]');
    var count = root.querySelector('[data-discovery-count]');
    var message = root.querySelector('[data-discovery-message]');
    var sort = root.querySelector('[data-discovery-sort]');
    var defaultSort = root.dataset.collectionDefaultSort === 'created-descending' ? 'newest' : 'featured';
    sort.value = defaultSort;
    var clear = root.querySelector('[data-discovery-clear]');
    var previous = root.querySelector('[data-discovery-previous]');
    var next = root.querySelector('[data-discovery-next]');
    var page = root.querySelector('[data-discovery-page]');
    var pagination = root.querySelector('.discovery-collection__pagination');
    var aquariumKeys = ['aquariumWater', 'aquariumVolume', 'aquariumWidth', 'aquariumSetup', 'aquariumSump', 'aquariumFiltration', 'aquariumColour'];
    var filterKeys = ['vendor', 'productType', 'stock', 'tag', 'filterCollection', 'minPrice', 'maxPrice'].concat(aquariumKeys);
    var routeTag = root.dataset.collectionTag || '';
    var query = new URL(window.location.href).searchParams;
    var state = { vendor: '', productType: '', stock: '', tag: routeTag, filterCollection: '', minPrice: '', maxPrice: '',
      aquariumWater: '', aquariumVolume: '', aquariumWidth: '', aquariumSetup: '', aquariumSump: '', aquariumFiltration: '', aquariumColour: '', offset: 0 };
    filterKeys.forEach(function (key) {
      var value = query.get('discovery_' + key);
      if (value !== null) state[key] = value;
    });
    var requestedPage = Number(query.get('page') || '1');
    if (Number.isSafeInteger(requestedPage) && requestedPage >= 1 && requestedPage <= 209) {
      state.offset = (requestedPage - 1) * pageSize;
    }
    var requestedSort = query.get('discovery_sort');
    if (requestedSort && Array.from(sort.options).some(function (option) { return option.value === requestedSort; })) {
      sort.value = requestedSort;
    }

    function pageUrl(number) {
      var url = new URL(window.location.href);
      if (number > 1) url.searchParams.set('page', String(number));
      else url.searchParams.delete('page');
      filterKeys.forEach(function (key) {
        if (state[key] !== '' && !(key === 'tag' && state.tag === routeTag)) {
          url.searchParams.set('discovery_' + key, state[key]);
        } else url.searchParams.delete('discovery_' + key);
      });
      if (sort.value !== defaultSort) url.searchParams.set('discovery_sort', sort.value);
      else url.searchParams.delete('discovery_sort');
      return url.pathname + url.search + url.hash;
    }

    function syncUrl() {
      window.history.replaceState(window.history.state, '', pageUrl(1));
    }
    var requestNumber = 0;
    var activeRequest;
    var productDetails = new Map();
    var customSwatchColours = Object.create(null);
    var expandedGroups = new Set();
    var expandedValues = new Set();
    var filtersHaveRendered = false;
    var mobileLayout = window.matchMedia('(max-width: 749px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var closeTimer;
    var openFrame;

    function setFiltersOpen(open, animate) {
      clearTimeout(closeTimer);
      if (openFrame) cancelAnimationFrame(openFrame);
      filterToggle.setAttribute('aria-expanded', String(open));
      filterToggle.setAttribute('aria-label', open ? 'Hide filters' : 'Show filters');
      filterToggleLabel.textContent = open ? 'Hide filters' : 'Show filters';
      if (mobileLayout.matches) {
        if (open) {
          filterPanel.hidden = false;
          filterPanel.inert = false;
          filterBackdrop.hidden = false;
          if (animate && !reducedMotion.matches) openFrame = requestAnimationFrame(function () {
            openFrame = requestAnimationFrame(function () {
              root.dataset.filtersOpen = 'true';
              openFrame = null;
            });
          });
          else root.dataset.filtersOpen = 'true';
          if (animate) closeFilters.focus();
        } else {
          root.dataset.filtersOpen = 'false';
          filterPanel.inert = true;
          closeTimer = setTimeout(function () {
            filterPanel.hidden = true;
            filterBackdrop.hidden = true;
          }, animate && !reducedMotion.matches ? 220 : 0);
          if (animate) filterToggle.focus();
        }
      } else {
        root.dataset.filtersOpen = String(open);
        filterPanel.hidden = !open;
        filterPanel.inert = !open;
        filterBackdrop.hidden = true;
      }
    }
    setFiltersOpen(false, false);
    mobileLayout.addEventListener('change', function () { setFiltersOpen(false, false); });

    function compactReviewCounts() {
      grid.querySelectorAll('.discovery-collection__rating-snippet').forEach(function (rating) {
        if (rating.childElementCount || rating.textContent.trim() || rating.getAttribute('aria-hidden') === 'true') {
          rating.closest('.discovery-collection__card').removeAttribute('data-reviews-loading');
        }
      });
      grid.querySelectorAll('.discovery-collection__rating-snippet .ruk-rating-snippet-count').forEach(function (label) {
        var visible = label.textContent.trim();
        if (/^\([\d,]+\s+Reviews?\)$/i.test(visible)) label.dataset.discoveryOriginalCount = visible;
        var original = label.dataset.discoveryOriginalCount;
        if (!original) return;
        var short = original.replace(/\s+Reviews?\)$/i, ')');
        var expected = mobileLayout.matches ? short : original;
        if (visible !== expected) label.textContent = expected;
      });
    }
    new MutationObserver(compactReviewCounts).observe(grid, {
      childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden']
    });
    mobileLayout.addEventListener('change', compactReviewCounts);

    function resetPage() { state.offset = 0; syncUrl(); load(); }

    function renderFields(view, priceRange) {
      if (filtersHaveRendered) {
        form.querySelectorAll('[data-filter-source]').forEach(function (group) {
          if (group.open) expandedGroups.add(group.dataset.filterSource);
          else expandedGroups.delete(group.dataset.filterSource);
        });
      }
      form.replaceChildren();
      if (!view || !Array.isArray(view.fields) || !view.fields.length) {
        filterToggle.hidden = true;
        setFiltersOpen(false, false);
        return;
      }
      view.fields.forEach(function (field) {
        if (!['vendor', 'productType', 'stock', 'tag', 'collection', 'price'].concat(aquariumKeys).includes(field.source)) return;
        var key = field.source === 'collection' ? 'filterCollection' : field.source;
        var values = Array.isArray(field.values) ? field.values.slice() : [];
        if (field.source !== 'price') {
          if (state[key] && !values.some(function (value) { return value.value === state[key]; })) {
            values.unshift({ value: state[key], label: state[key], count: 0 });
          }
          if (values.filter(function (value) { return Number(value.count) > 0; }).length <= 1 && !state[key]) return;
        } else if (!priceRange || !Number.isFinite(priceRange.min) || !Number.isFinite(priceRange.max) ||
          priceRange.max <= priceRange.min) return;
        var group = element('details', 'discovery-collection__field');
        group.dataset.filterSource = field.source;
        if (!filtersHaveRendered || expandedGroups.has(field.source)) group.open = true;
        var heading = element('summary', 'discovery-collection__field-heading');
        heading.appendChild(element('span', null, field.label));
        group.appendChild(heading);
        var options = element('div', 'discovery-collection__field-options');
        if (field.source === 'price') {
          var pair = element('div', 'discovery-collection__price');
          var limits = element('div', 'discovery-collection__price-values');
          var minLabel = element('span');
          var maxLabel = element('span');
          limits.appendChild(minLabel); limits.appendChild(maxLabel);
          pair.appendChild(limits);
          var track = element('div', 'discovery-collection__price-track');
          pair.appendChild(track);
          var lower = Math.floor(priceRange.min);
          var upper = Math.ceil(priceRange.max);
          var rangeInputs = {};
          ['minPrice', 'maxPrice'].forEach(function (key) {
            var input = element('input');
            input.type = 'range'; input.min = String(lower); input.max = String(upper); input.step = '1'; input.name = key;
            input.value = String(Math.min(upper, Math.max(lower, Number(state[key] || (key === 'minPrice' ? lower : upper)))));
            input.setAttribute('aria-label', key === 'minPrice' ? 'Minimum price in pounds' : 'Maximum price in pounds');
            rangeInputs[key] = input;
            pair.appendChild(input);
          });
          var paintPriceRange = function (changed) {
            var minimum = Number(rangeInputs.minPrice.value);
            var maximum = Number(rangeInputs.maxPrice.value);
            if (minimum > maximum) {
              if (changed === 'minPrice') rangeInputs.minPrice.value = String(maximum);
              else rangeInputs.maxPrice.value = String(minimum);
              minimum = Number(rangeInputs.minPrice.value);
              maximum = Number(rangeInputs.maxPrice.value);
            }
            minLabel.textContent = money.format(minimum);
            maxLabel.textContent = money.format(maximum);
            pair.style.setProperty('--price-start', ((minimum - lower) / (upper - lower) * 100) + '%');
            pair.style.setProperty('--price-end', ((maximum - lower) / (upper - lower) * 100) + '%');
          };
          pair.addEventListener('input', function (event) { paintPriceRange(event.target.name); });
          pair.addEventListener('change', function () {
            state.minPrice = Number(rangeInputs.minPrice.value) === lower ? '' : rangeInputs.minPrice.value;
            state.maxPrice = Number(rangeInputs.maxPrice.value) === upper ? '' : rangeInputs.maxPrice.value;
            resetPage();
          });
          paintPriceRange();
          options.appendChild(pair);
        } else {
          values.forEach(function (value, valueIndex) {
            var option = element('label', 'discovery-collection__option');
            if (valueIndex >= 5 && !expandedValues.has(field.source)) option.hidden = true;
            var input = element('input');
            input.type = 'radio'; input.name = key; input.value = value.value;
            input.checked = state[key] === value.value;
            option.appendChild(input);
            option.appendChild(element('span', 'discovery-collection__option-label', value.label));
            option.appendChild(element('span', 'discovery-collection__option-count', '(' + Number(value.count || 0).toLocaleString('en-GB') + ')'));
            options.appendChild(option);
          });
          if (values.length > 5) {
            var more = element('button', 'discovery-collection__view-all', expandedValues.has(field.source) ? 'View less' : 'View all');
            more.type = 'button'; more.dataset.showAll = field.source;
            options.appendChild(more);
          }
        }
        group.appendChild(options);
        form.appendChild(group);
      });
      filterToggle.hidden = !form.childElementCount;
      if (!form.childElementCount) setFiltersOpen(false, false);
      filtersHaveRendered = true;
    }

    function renderBannerSlot(target, banners, slot) {
      if (!target) return;
      target.replaceChildren();
      banners.filter(function (banner) { return banner.slot === slot; }).forEach(function (banner) {
        var node = bannerNode(banner, false);
        if (node) { target.appendChild(node); if (bannerSession) bannerSession.record(banner); }
      });
    }

    function renderHits(hits, banners) {
      grid.replaceChildren();
      window.DiscoveryBannerSession.gridTiles(hits.length, banners).forEach(function (tile) {
        if (tile.kind === 'banner') {
          var campaign = bannerNode(tile.item, true);
          if (campaign) { grid.appendChild(campaign); if (bannerSession) bannerSession.record(tile.item); }
          return;
        }
        var hit = hits[tile.index];
        var path = safeProductPath(hit.url);
        if (!path) return;
        var article = element('article', 'discovery-collection__card');
        article.dataset.reviewsLoading = 'true';
        article.dataset.deliveryLoading = 'true';
        article.dataset.swatchesLoading = 'true';
        var link = element('a');
        link.href = path;
        var media = element('span', 'discovery-collection__media');
        var imageUrl = safeImageUrl(hit.imageUrl);
        if (imageUrl) {
          var image = element('img');
          image.src = imageUrl; image.alt = '';
          image.loading = 'lazy';
          media.appendChild(image);
        }
        var badgeSlot = element('charterhouse-promotions', 'discovery-collection__badges charterhouse-promotions--collection');
        badgeSlot.setAttribute('kind', 'badge');
        badgeSlot.setAttribute('product-id', hit.shopifyId.replace('gid://shopify/Product/', ''));
        badgeSlot.setAttribute('collection-id', collectionId.replace('gid://shopify/Collection/', ''));
        link.appendChild(media);
        link.appendChild(element('h3', null, hit.title));
        if (hit.price !== null && hit.currency === 'GBP') {
          var price = Number(hit.price);
          if (Number.isFinite(price)) {
            var priceLine = element('p', 'discovery-collection__card-price');
            var compareAt = Number(hit.compareAtPrice);
            if (hit.compareAtPrice !== null && hit.compareAtPrice !== undefined &&
              Number.isFinite(compareAt) && compareAt > price) {
              priceLine.classList.add('discovery-collection__card-price--sale');
              priceLine.appendChild(element('span', 'discovery-collection__sale-price', money.format(price)));
              var originalPrice = element('s', 'discovery-collection__compare-price', money.format(compareAt));
              originalPrice.setAttribute('aria-label', 'Was ' + money.format(compareAt));
              priceLine.appendChild(originalPrice);
            } else priceLine.textContent = money.format(price);
            link.appendChild(priceLine);
          }
        }
        article.appendChild(link);
        article.appendChild(badgeSlot);
        var details = element('div', 'discovery-collection__details');
        var detailSkeleton = element('div', 'discovery-collection__details-skeleton');
        detailSkeleton.setAttribute('aria-hidden', 'true');
        ['review', 'delivery', 'swatches'].forEach(function (detail) {
          detailSkeleton.appendChild(element('span', 'discovery-collection__detail-placeholder--' + detail));
        });
        details.appendChild(detailSkeleton);
        article.appendChild(details);
        var review = element('div', 'discovery-collection__review');
        var rating = element('span', 'ruk_rating_snippet discovery-collection__rating-snippet');
        rating.dataset.sku = productHandle(path) + ';' + hit.shopifyId.replace('gid://shopify/Product/', '');
        review.appendChild(rating);
        details.appendChild(review);
        var delivery = element('div', 'discovery-collection__delivery');
        delivery.hidden = true;
        details.appendChild(delivery);
        renderSiblingSwatches(article, hit, customSwatchColours);
        if (article.querySelector('.discovery-collection__swatches')) article.removeAttribute('data-swatches-loading');
        article.dataset.productHandle = productHandle(path);
        grid.appendChild(article);
      });
      var renderedCards = Array.from(grid.querySelectorAll('.discovery-collection__card'));
      setTimeout(function () {
        ['reviews', 'delivery', 'swatches'].forEach(function (detail) { finishCardLoading(renderedCards, detail); });
      }, 12000);
    }

    function renderSkeleton() {
      grid.replaceChildren();
      grid.setAttribute('aria-busy', 'true');
      for (var index = 0; index < pageSize; index++) {
        var card = element('div', 'discovery-collection__skeleton');
        card.setAttribute('aria-hidden', 'true');
        var summary = element('div', 'discovery-collection__skeleton-summary');
        summary.appendChild(element('span', 'discovery-collection__skeleton-media'));
        summary.appendChild(element('span', 'discovery-collection__skeleton-title'));
        summary.appendChild(element('span', 'discovery-collection__skeleton-detail'));
        card.appendChild(summary);
        card.appendChild(element('span', 'discovery-collection__skeleton-review'));
        var delivery = element('div', 'discovery-collection__skeleton-delivery discovery-collection__delivery');
        delivery.appendChild(element('span'));
        card.appendChild(delivery);
        card.appendChild(element('span', 'discovery-collection__skeleton-swatches'));
        grid.appendChild(card);
      }
    }

    async function preloadCardDetails(cards) {
      var config = document.querySelector('[data-discovery-card-details-config]');
      if (!config) return;
      var endpoint;
      try {
        endpoint = new URL(JSON.parse(config.textContent).endpoint, window.location.origin);
        if (endpoint.origin !== window.location.origin || !endpoint.searchParams.get('view')) return;
      } catch (_) { return; }
      var handles = Array.from(new Set(cards.map(function (card) { return card.dataset.productHandle; })))
        .filter(function (handle) { return /^[a-z0-9-]{1,128}$/.test(handle || '') && !productDetails.has(handle); });
      var batches = [];
      for (var start = 0; start < handles.length; start += 12) batches.push(handles.slice(start, start + 12));
      await Promise.all(batches.map(async function (batch) {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 4000);
        try {
          var url = new URL(endpoint.href);
          url.searchParams.set('q', batch.join('|'));
          url.searchParams.set('type', 'product');
          var response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) return;
          var data = await response.json();
          if (data.schemaVersion !== 1 || !Array.isArray(data.products)) return;
          data.products.forEach(function (item) {
            if (!item || !batch.includes(item.handle) || !/^\d+$/.test(String(item.id)) ||
              !Array.isArray(item.options) || !Array.isArray(item.variants) || !item.variants.length ||
              item.variantCount !== item.variants.length) return;
            if (!item.variants.every(function (variant) {
              return variant && /^\d+$/.test(String(variant.id)) && Array.isArray(variant.options);
            })) return;
            productDetails.set(item.handle, item);
          });
        } catch (_) { /* Individual lookups remain available if the theme batch is unavailable. */ }
        finally { clearTimeout(timer); }
      }));
    }

    async function hydrateCards(current) {
      var cards = Array.from(grid.querySelectorAll('.discovery-collection__card'));
      var reviewsReady = ensureReviewsWidget().catch(function () { return null; });
      await preloadCardDetails(cards);
      if (current !== requestNumber) return;
      var details = [];
      var cursor = 0;
      async function worker() {
        while (cursor < cards.length) {
          var card = cards[cursor++];
          var handle = card.dataset.productHandle;
          if (!handle) continue;
          try {
            if (!productDetails.has(handle)) {
              var response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
              if (!response.ok) throw new Error('Product details unavailable');
              productDetails.set(handle, await response.json());
            }
            if (current !== requestNumber || !card.isConnected) return;
            var item = productDetails.get(handle);
            var variants = Array.isArray(item.variants) ? item.variants : [];
            renderColourSwatches(card, item, '/products/' + encodeURIComponent(handle), customSwatchColours);
            var rating = card.querySelector('.discovery-collection__rating-snippet');
            rating.dataset.sku = [item.handle, ...variants.map(function (variant) { return variant.sku; }).filter(Boolean),
              ...variants.map(function (variant) { return variant.id; }), item.id].join(';');
            var variantIds = variants.map(function (variant) { return String(variant.id); })
              .filter(function (id) { return /^\d+$/.test(id); });
            if (variantIds.length) details.push({ card: card, variantIds: variantIds });
          } catch (_) { /* A product card still works without its extra details. */ }
          finally { card.removeAttribute('data-swatches-loading'); }
        }
      }
      await Promise.all(Array.from({ length: Math.min(4, cards.length) }, worker));
      if (current !== requestNumber) return;
      reviewsReady.then(function () {
        if (current !== requestNumber) return;
        if (typeof window.ratingSnippet !== 'function') { finishCardLoading(cards, 'reviews'); return; }
        cards.forEach(function (card) {
          var rating = card.querySelector('.discovery-collection__rating-snippet');
          if (!rating.childElementCount && !rating.textContent.trim()) {
            rating.removeAttribute('aria-hidden');
            card.dataset.reviewsLoading = 'true';
          }
        });
        window.ratingSnippet('ruk_rating_snippet', {
          store: window.reviewsIoStore || 'charterhouse-aquatics.myshopify.com', color: '#eab308',
          textClr: '#71717a', linebreak: false, usePolaris: true, text: 'Reviews', lang: 'en',
          mode: 'default', showEmptyStars: false
        });
        setTimeout(function () { finishCardLoading(cards, 'reviews'); }, 5000);
      }).catch(function () { finishCardLoading(cards, 'reviews'); });
      var ids = Array.from(new Set(details.flatMap(function (entry) { return entry.variantIds; })));
      if (!ids.length) { finishCardLoading(cards, 'delivery'); return; }
      try {
        var config = document.querySelector('[data-charterhouse-delivery-config]');
        var endpoint = config ? JSON.parse(config.textContent).endpoint : '/apps/charterhouse-delivery';
        if (typeof endpoint !== 'string' || !endpoint.startsWith('/') || endpoint.startsWith('//')) return;
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 8000);
        var batches = [];
        for (var start = 0; start < ids.length; start += 80) batches.push(ids.slice(start, start + 80));
        var responses = await Promise.all(batches.map(async function (batch) {
          var response = await fetch(endpoint, {
            method: 'POST', credentials: 'same-origin', signal: controller.signal,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ lines: batch.map(function (id) {
              return { variantId: 'gid://shopify/ProductVariant/' + id, quantity: 1 };
            }) })
          });
          return response.ok ? response.json() : null;
        }));
        if (current !== requestNumber) return;
        var estimates = new Map();
        var messages = {};
        responses.forEach(function (data) {
          if (!data) return;
          (data.estimates || []).forEach(function (item) { estimates.set(item.variantId, item); });
          if (data.messages && typeof data.messages === 'object') messages = data.messages;
        });
        details.forEach(function (entry) {
          if (!entry.card.isConnected || current !== requestNumber) return;
          var result = bestVariantEstimate(entry.variantIds, estimates);
          var message = deliveryMessage(result, messages);
          if (!message) return;
          var node = entry.card.querySelector('.discovery-collection__delivery');
          var firstVariantId = 'gid://shopify/ProductVariant/' + entry.variantIds[0];
          node.textContent = result.variantId !== firstVariantId ? 'Other options: ' + message.text : message.text;
          node.dataset.tone = message.tone;
          node.hidden = false;
        });
      } catch (_) { /* Delivery availability must not block the product grid. */ }
      finally { clearTimeout(timer); finishCardLoading(cards, 'delivery'); }
    }

    function renderPagination(total) {
      var pageCount = Math.ceil(total / pageSize);
      var currentPage = Math.floor(state.offset / pageSize) + 1;
      pagination.hidden = pageCount <= 1;
      page.replaceChildren();
      if (pageCount <= 1) return;
      var pages = new Set([1, pageCount]);
      for (var index = Math.max(1, currentPage - 1); index <= Math.min(pageCount, currentPage + 1); index++) {
        pages.add(index);
      }
      if (currentPage <= 2) pages.add(Math.min(3, pageCount));
      var last = 0;
      Array.from(pages).sort(function (a, b) { return a - b; }).forEach(function (number) {
        if (number - last > 1) page.appendChild(element('span', 'discovery-collection__pagination-ellipsis', '…'));
        var link = element('a', 'discovery-collection__page-number', number);
        link.href = pageUrl(number);
        link.setAttribute('aria-label', 'Page ' + number);
        if (number === currentPage) link.setAttribute('aria-current', 'page');
        page.appendChild(link);
        last = number;
      });
    }

    async function load() {
      var current = ++requestNumber;
      if (activeRequest) activeRequest.abort();
      var controller = new AbortController();
      activeRequest = controller;
      var timeout = setTimeout(function () { controller.abort(); }, 20000);
      var url = new URL('/api/discovery/collection', apiBase);
      url.searchParams.set('handle', handle);
      url.searchParams.set('limit', String(pageSize));
      url.searchParams.set('offset', String(state.offset));
      url.searchParams.set('sort', sort.value);
      filterKeys.forEach(function (key) {
        if (state[key] !== '') url.searchParams.set(key, state[key]);
      });
      count.textContent = 'Loading products…';
      message.hidden = true;
      renderSkeleton();
      try {
        var response = await fetch(url.href, { mode: 'cors', credentials: 'omit', signal: controller.signal });
        if (!response.ok) throw new Error('Discovery returned HTTP ' + response.status);
        var data = await response.json();
        if (current !== requestNumber) return;
        if (data.schemaVersion !== 1 || !Array.isArray(data.hits)) throw new Error('Unsupported Discovery response');
        customSwatchColours = data.swatchColours && typeof data.swatchColours === 'object' && !Array.isArray(data.swatchColours)
          ? Object.assign(Object.create(null), data.swatchColours) : Object.create(null);
        var featuredOption = sort.querySelector('option[value="featured"]');
        if (featuredOption) featuredOption.textContent = data.popularity ? 'Most popular' : 'Featured';
        recordPageView();
        renderFields(data.filterView, data.priceRange);
        var banners = data.bannerView && Array.isArray(data.bannerView.items) ? data.bannerView.items : [];
        if (bannerSession) banners = bannerSession.select(banners);
        renderBannerSlot(emptyStateBanners, banners, 'empty-state');
        renderHits(data.hits, banners);
        grid.removeAttribute('aria-busy');
        hydrateCards(current).catch(function () { /* Optional product details must not block browsing. */ });
        count.textContent = 'Found ' + Number(data.total).toLocaleString('en-GB') + ' ' + (data.total === 1 ? 'item' : 'items');
        clear.hidden = !filterKeys.some(function (key) { return state[key] !== '' && !(key === 'tag' && state.tag === routeTag); });
        if (state.offset === 0) previous.removeAttribute('href');
        else previous.href = pageUrl(Math.floor(state.offset / pageSize));
        if (data.page.hasMore) next.href = pageUrl(Math.floor(state.offset / pageSize) + 2);
        else next.removeAttribute('href');
        renderPagination(data.total);
        if (!data.total) {
          message.textContent = 'No products match these filters.';
          message.hidden = false;
        }
      } catch (_) {
        if (current !== requestNumber) return;
        grid.replaceChildren();
        grid.removeAttribute('aria-busy');
        if (emptyStateBanners) emptyStateBanners.replaceChildren();
        count.textContent = 'Products unavailable';
        message.textContent = 'We could not load the Discovery preview. Please try again later.';
        message.hidden = false;
        previous.removeAttribute('href'); next.removeAttribute('href'); page.replaceChildren(); pagination.hidden = true;
      } finally {
        clearTimeout(timeout);
        if (activeRequest === controller) activeRequest = null;
      }
    }

    form.addEventListener('click', function (event) {
      var more = event.target.closest('[data-show-all]');
      if (!more || !form.contains(more)) return;
      var source = more.dataset.showAll;
      if (expandedValues.has(source)) expandedValues.delete(source);
      else expandedValues.add(source);
      var group = more.closest('[data-filter-source]');
      group.querySelectorAll('.discovery-collection__option').forEach(function (option, index) {
        option.hidden = index >= 5 && !expandedValues.has(source);
      });
      more.textContent = expandedValues.has(source) ? 'View less' : 'View all';
    });
    form.addEventListener('change', function (event) {
      if (event.target.type === 'range') return;
      if (!event.target.name || !(event.target.name in state)) return;
      state[event.target.name] = event.target.value;
      resetPage();
    });
    filterToggle.addEventListener('click', function () {
      setFiltersOpen(root.dataset.filtersOpen !== 'true', true);
    });
    filterBackdrop.addEventListener('click', function () { setFiltersOpen(false, true); });
    closeFilters.addEventListener('click', function () { setFiltersOpen(false, true); });
    applyFilters.addEventListener('click', function () { setFiltersOpen(false, true); });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && mobileLayout.matches && root.dataset.filtersOpen === 'true') setFiltersOpen(false, true);
    });
    sort.addEventListener('change', resetPage);
    clear.addEventListener('click', function () {
      filterKeys.forEach(function (key) { state[key] = key === 'tag' ? routeTag : ''; });
      resetPage();
    });
    load();
  }

  function boot(container) {
    container.querySelectorAll('[data-discovery-collection]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
